// Pure helpers for resolving project scope from current_access_context().
// Project UUIDs are database identities and must not be hardcoded into the browser.

/**
 * Resolve exactly one accessible project by project code.
 * Returns null for missing, malformed or ambiguous matches so callers fail closed.
 * @param {*} context result of current_access_context()
 * @param {string} projectCode stable project code, for example "ams11"
 * @returns {*|null}
 */
export function findUniqueProjectByCode(context, projectCode) {
  const projects = context?.projects;
  if (!Array.isArray(projects)) return null;

  const normalizedCode = String(projectCode ?? "").trim().toLowerCase();
  if (!normalizedCode) return null;

  const matches = projects.filter((project) =>
    typeof project?.project_code === "string" &&
    project.project_code.trim().toLowerCase() === normalizedCode
  );

  return matches.length === 1 ? matches[0] : null;
}
